import { Stack } from '@chakra-ui/layout';
import { Box, Button, Checkbox, CheckboxGroup, Flex, Heading, Text, useCheckboxGroup } from '@chakra-ui/react';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { SignUpContext } from '@/containers/SignUp/components/SignUpContext';

const INTERESTS = [
  'computer_science',
  'life_sciences',
  'health_sciences',
  'social_sciences',
  'physics',
  'library_updates',
  'event_updates',
];

export const Interests: FC = () => {
  const { t } = useTranslation();
  const { setSignUpProps, setCurrentStep, signUpProps } = useContext(SignUpContext);
  const { value, getCheckboxProps } = useCheckboxGroup({ defaultValue: signUpProps.interests });

  function handleNextClick() {
    const interests = value.map((v) => v.toString());

    setSignUpProps((snp) => ({ ...snp, interests }));
    setCurrentStep((cs) => cs + 1);
  }

  return (
    <Flex w="full" justifyContent="space-around" flexDirection={{ base: 'column', lg: 'row' }}>
      <Flex mb={14} maxW="390px" gap={8} flexDirection="column" flex={1}>
        <Text color="gray.600">{`2 / 3`}</Text>
        <Heading fontSize="5xl">{t('createAccount.interests.title')}</Heading>
        <Text mt={13}>{t('createAccount.interests.description')}</Text>
      </Flex>
      <Flex flexDirection="column" maxW="390px" flex={1}>
        <Text>{t('createAccount.interests.selectInterests')}</Text>
        <CheckboxGroup colorScheme="violet" defaultValue={signUpProps.interests}>
          <Stack mt={8} spacing={6} direction="column">
            {INTERESTS.map((interest, i) => (
              <Checkbox
                lineHeight={1}
                spacing={4}
                size="lg"
                color="black"
                key={interest}
                {...getCheckboxProps({ value: interest })}
              >
                {t(`createAccount.interests.interestsList.${i}`)}
              </Checkbox>
            ))}
          </Stack>
        </CheckboxGroup>
        <Box mt={24}>
          <Button onClick={handleNextClick} isDisabled={value.length === 0} variant="outline" w="130px" type="button">
            {t('action.next')}
          </Button>
        </Box>
      </Flex>
    </Flex>
  );
};
